import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, type InjectedFormProps } from 'redux-form';

import { ButtonTypes } from '~/components/Button';
import FormSection, { Column, InputContainer, Row } from '~/components/FormSection/FormSection';
import { SelectField } from '~/components/Select';
import options from '~/components/Select/options';
import SubmitButton from '~/components/SubmitButton/SubmitButton';
import { getDefaultDistanceUnit, getDefaultWeightUnit } from '~/selectors/packages.selectors';
import { distanceOptionsBuilder, weightOptionsBuilder } from '~/utils/packages';

import { type ApplicationState } from '../../../store';

class DefaultPackageUnitsForm extends React.Component<
  DefaultPackageUnitsFormStateProps & InjectedFormProps
> {
  componentDidUpdate(prevProps) {
    if (!this.props.anyTouched) {
      if (prevProps.defaultWeightUnit !== this.props.defaultWeightUnit) {
        this.props.change(
          'defaultWeightUnit',
          options.commonWeightOptions[this.props.defaultWeightUnit],
        );
      }
      if (prevProps.defaultDistanceUnit !== this.props.defaultDistanceUnit) {
        this.props.change(
          'defaultDistanceUnit',
          options.commonDistanceOptions[this.props.defaultDistanceUnit],
        );
      }
    }
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <FormSection>
          <Row>
            <Column width="100%">
              <InputContainer>
                <Field
                  component={SelectField}
                  label="Default weight unit"
                  name="defaultWeightUnit"
                  options={weightOptionsBuilder()}
                  size="100%"
                />
              </InputContainer>
              <InputContainer>
                <Field
                  component={SelectField}
                  label="Default dimension unit"
                  name="defaultDistanceUnit"
                  options={distanceOptionsBuilder()}
                  size="100%"
                  style={{ minWidth: '100%' }}
                />
              </InputContainer>
              {/*Hiding until this is implemented in the label flows*/}
              {/*<Field*/}
              {/*name="is_use_imported_orders_weight"*/}
              {/*component={CheckboxField}*/}
              {/*label="Use imported order weight in label purchase"*/}
              {/*/>*/}
              <div>
                <SubmitButton
                  buttonType={ButtonTypes.Primary}
                  preSubmitText="Save"
                  submittedSuccess={this.props.submitSucceeded}
                  submitting={this.props.submitting}
                  successSubmitText="Saved"
                  type="submit"
                />
              </div>
            </Column>
          </Row>
        </FormSection>
      </form>
    );
  }
}

interface DefaultPackageUnitsFormStateProps {
  defaultDistanceUnit: string;
  defaultWeightUnit: string;
}

const mapStateToProps = (state: ApplicationState) => ({
  defaultDistanceUnit: getDefaultDistanceUnit(state),
  defaultWeightUnit: getDefaultWeightUnit(state),
});

export const DEFAULT_PACKAGE_UNITS_FORM = 'DEFAULT_PACKAGE_UNITS_FORM';

const ComposedDefaultPackageUnitsForm =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  compose<any>(
    reduxForm({ form: DEFAULT_PACKAGE_UNITS_FORM }),
    connect(mapStateToProps),
  )(DefaultPackageUnitsForm);

export default ComposedDefaultPackageUnitsForm;
